/* JudgeMe Reviews Widget - Layout enhancements to match Figma design */
(function() {
  'use strict';

  function enhanceReviews() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;

    const reviewItems = widget.querySelectorAll('.jm-review-item');
    if (!reviewItems.length) return;

    reviewItems.forEach(function(item) {
      if (item.dataset.enhanced) return;
      item.dataset.enhanced = 'true';

      /* Add "Vérifié" badge next to reviewer name */
      var nameEl = item.querySelector('.jm-reviewer-info__name');
      if (nameEl && !nameEl.parentElement.querySelector('.jm-verified-badge')) {
        var badge = document.createElement('span');
        badge.className = 'jm-verified-badge';
        badge.textContent = window.theme?.strings?.verified || 'Vérifié';
        nameEl.insertAdjacentElement('afterend', badge);
      }

      /* Move date to the stars row (top-right) */
      var reviewerInfo = item.querySelector('.jm-reviewer-info');
      if (reviewerInfo) {
        var dateCluster = reviewerInfo.closest('.jm-review-item__content')
          ? reviewerInfo.closest('.jm-review-item__content').querySelector('.jm-stack--space-100 .jm-cluster:last-child')
          : null;

        if (dateCluster) {
          var dateText = dateCluster.querySelector('.jm-text');
          if (dateText) {
            var starsRow = item.querySelector('.jm-review-item__content > .jm-cluster:first-child');
            if (starsRow && !starsRow.querySelector('.jm-date-moved')) {
              var dateSpan = document.createElement('span');
              dateSpan.className = 'jm-date-moved';
              dateSpan.style.cssText = 'margin-left:auto;font-family:Figtree,sans-serif;font-size:12px;line-height:18px;color:rgba(30,30,30,0.5);flex-shrink:0;';
              dateSpan.textContent = dateText.textContent.trim();
              starsRow.appendChild(dateSpan);
              dateCluster.style.display = 'none';
            }
          }
        }
      }
    });
  }

  /* Run on load and observe for dynamic content (pagination, etc.) */
  function init() {
    enhanceReviews();

    var widget = document.getElementById('judgeme_product_reviews');
    if (widget) {
      var observer = new MutationObserver(function() {
        enhanceReviews();
      });
      observer.observe(widget, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 1000);
    });
  } else {
    setTimeout(init, 1000);
  }
})();
